import type {ActionType} from 'constants/flow/flowTypes';
import type {QuoteItemsType} from 'constants/flow/flowTypesCart';
import {CART, QUOTE_ITEM} from 'constants/actions';

import type {UpsellItemsType, UpsellItemType} from './upsellItemsType';

const initialState = {items: {}, status: ''};

/**
 * Returns changed upsell items
 * @param {UpsellItemsType} state current state
 * @param {{
        id: string,
        alias: string,
    }} selectedUpsellData of cart item
 * @param {boolean} value for isAdded property
 * @returns {Array<UpsellItemType>} items with updeted upsell
 */
const getChangedItems = (
    state: UpsellItemsType,
    selectedUpsellData: {
        id: string,
        name: string,
    },
    value: boolean,
): Array<UpsellItemType> => {
    const {items} = state;
    const {id: cartItemId, name: alias} = selectedUpsellData;
    const selectedUpsell = items[cartItemId].find(
        (upsell: UpsellItemType) => upsell.alias === alias,
    );
    if (selectedUpsell) selectedUpsell.isAdded = value;
    return {...items};
};

/**
 * Upsell items in cart
 * @param {UpsellItemsType} state Current state
 * @param {ActionType<QuoteItemsType>} action Received action
 * @returns {UpsellItemsType} upsell items data
 */
export default function upsellItems(
    state: UpsellItemsType = initialState,
    action: ActionType<QuoteItemsType>,
): UpsellItemsType {
    switch (action.type) {
        case `${CART.ADD_UPSELL_ITEM}_FULFILLED`:
        case `${CART.REMOVE_UPSELL_ITEM}_FULFILLED`:
        case `${QUOTE_ITEM.GET_ITEMS}_FULFILLED`: {
            const {
                data: {quoteItems},
            } = action.payload;

            const items = quoteItems.reduce(
                (result, item) => ({
                    ...result,
                    [item.id]: item.upsellData ? item.upsellData.slice(0) : [],
                }),
                {},
            );

            return {
                status: 'fulfilled',
                items,
            };
        }
        case `${CART.ADD_UPSELL_ITEM}_PENDING`:
            return {...state, items: getChangedItems(state, action.meta, true), status: ''};

        case `${CART.REMOVE_UPSELL_ITEM}_PENDING`:
            return {
                ...state,
                items: getChangedItems(state, action.meta, false),
                status: '',
            };

        default:
            return state;
    }
}
